import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42k2LUQqAMAxDd/8bqheY4LYKc7piG3EfXQMJJLwEON2toffHT2/4U1WHt3XBHqN1A0rOSOkAUcFJhKtWMPMERMTs3gP4AFk/fX+kuE8/AAAAAElFTkSuQmCC"};
